export const raffleBuyTicketModal = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '0 35px 48px',
		width: '100%',
	},

	contentWrap: {
		width: '100%',
	},

	title: {
		fontWeight: '700',
		fontSize: '20px',
		textAlign: 'center',
		color: 'var(--neutral-900)',
		marginBottom: '40px',
	},

	listTitle: {
		fontWeight: '700',
		textAlign: 'center',
		color: 'var(--neutral-900)',
		marginBottom: '24px',
	},

	btnWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		maxWidth: '370px',
	},

	btn: {
		width: '100%',
		'&:first-of-type': {
			marginRight: '16px',
		},
	},

	feeWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: '26px',
	},

	feeLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: '7px',
		'& .checked': {
			path: {
				fill: 'var(--primary-500)',
			},
		},
	},

	tiersWrap: {
		width: '100%',
		maxWidth: '495px',
		margin: '0 10px 40px',
		backgroundColor: 'var(--neutral-50)',
		borderRadius: '8px',
		padding: '24px',
	},

	paymentWrap: {
		marginBottom: '40px',
	},
};
